<template>
  <div class="contents-wrapper">
    <div class="contents-header">
      <div class="nav">
        <router-link to="/"><img :src="scroll_event_homeImage" /></router-link>
      </div>
    </div>
    <div class="contents-body">
      <div class="portfolio-top" />
      <div class="title">
        <h1 id="title">Magic table</h1>
        <p id="role">Product design, UI library<br />2018</p>
      </div>

      <div class="desc">
        <p id="desc">
          <b>Description</b><br />마케터를 위한 다채널 광고데이터 분석
          솔루션.<br />디자인 시스템 가이드와 UI 라이브러리를 만들고, 이를
          적용하여 UI/GUI 화면을 디자인하였다.
        </p>
        <p id="name">
          <b>UI/GUI Design:</b> Yuri Ahn<br /><b>Brand Design:</b> Yuri Ahn<br /><b
            >Front-end programming:</b
          >
          Jeongwoo Ahn, Jieun Kim, Sanghwan Jun<br /><b
            >Back-end programming:</b
          >
          Yoonhong Min, Sanghwan Jun<br /><b>UX planning:</b> Soyeon Kwon<br /><b
            >Product managing:</b
          >
          Jihyun Lim<br /><br /><a
            style="color: #303133"
            href="https://newsjelly.github.io/mtui/#/"
            target="_blank"
            >View UI Library</a
          ><br /><a
            style="color: #303133"
            href="https://www.magictbl.com/"
            target="_blank"
            >View Website</a
          >
        </p>
      </div>
      <div class="img-contents">
        <img src="/images/portfolios/mgtable/01.png" />
        <img class="mini" src="/images/portfolios/mgtable/02.png" />
        <img class="mini" src="/images/portfolios/mgtable/03.png" />
        <img class="mini" src="/images/portfolios/mgtable/06.svg" />
        <img class="mini" src="/images/portfolios/mgtable/07.svg" />
        <img class="mini" src="/images/portfolios/mgtable/08.svg" />
        <img class="mini" src="/images/portfolios/mgtable/09.svg" />
      </div>
    </div>
    <div class="move-btn">
      <span class="prev" @click="move('alice')">
        <img src="/images/chevron-left.svg" />Previous
      </span>
      <span class="next" @click="move('mooovr')">
        Next<img src="/images/chevron-right.svg" />
      </span>
    </div>
    <div class="contents-footer">
      <span class="name">
        <img src="/images/home_full_name.svg" />
      </span>
      <span class="copyright">
        <p>2021 ⓒ ahnyuri</p>
      </span>
    </div>
  </div>
</template>

<script>
import { ScrollEventMixin } from "@/mixins/ScrollEventMixin";
export default {
  name: "DetailMgtable",
  mixins: [ScrollEventMixin],
  data() {
    return {};
  },
  methods: {
    move(url) {
      this.$router.push(`/detail/${url}`);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/views/HomeHeader.scss";
@import "@/views/HomeFooter.scss";
.contents-body {
  // display: flex;
  // outline: 1px red dashed;
  // height: 1500px;
}
.contents-wrapper {
  overflow-x: hidden;
}
.portfolio-top {
  width: 100%;
  height: 800px;
  margin: 0 auto;
  background-repeat: no-repeat;
  background-position: center;
  background-size: 100%;
  background-image: url("/images/portfolios/mgtable/top.svg");
}

.title {
  float: left;
  margin-left: 10%;
  display: inline-block;
  margin-bottom: 0;
}

.title h1 {
  color: #303133;
  margin-top: 100px;
}
.title p {
  font-size: 13px;
  line-height: 20px;
  color: #606266;
  margin-top: -5px;
}
.desc {
  float: right;
  margin-right: 10%;
  margin-top: 85px;
  margin-bottom: 100px;
  width: 550px;
  font-size: 16px;
  line-height: 26px;
  color: #606266;
  display: inline-block;
}

.img-contents img {
  width: 80%;
  margin-left: 10%;
  margin-right: 10%;
  margin-top: 50px;
}

.img-contents img.mini {
  width: 80%;
  margin-left: 10%;
  margin-right: 10%;
  margin-top: -5px;
}

.move-btn {
  cursor: pointer;
  width: 100%;
  display: inline-block;
}
.move-btn a {
  cursor: pointer;
}
.move-btn > .prev {
  color: #606266;
  margin-left: 5%;
  margin-top: 100px;
  margin-bottom: 100px;
  float: left;
}
.prev:hover {
  color: #303133;
}
.move-btn > .next {
  color: #606266;
  margin-right: 5%;
  margin-top: 100px;
  margin-bottom: 100px;
  float: right;
}
.next:hover {
  color: #303133;
}
@import "@/views/DetailZMedia.scss";
</style>
